<ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
    @for (item of list; track item.text) {
        @if (item.submenu) {
            <li
                nz-submenu
                [nzOpen]="item.defaultOpened"
                [nzTitle]="item.title || item.text | translate"
                [nzIcon]="item.icon || null"
            >
                <ul>
                    @for (child of item.children; track child.text) {
                        <li
                            nz-menu-item
                            [nzSelected]="matcher(child, child.matcher)"
                            [title]="child.title || child.text | translate"
                        >
                            <a
                                (click)="onClickEvent($event, child)"
                                [routerLink]="child.link"
                                [queryParams]="
                                    child.callback ? undefined : getQueryParamsForLink(child)
                                "
                            >
                                @if (child.icon) {
                                    <nz-icon [nzType]="child.icon" />
                                }
                                {{ child.text | translate }}
                            </a>
                        </li>
                    }
                </ul>
            </li>
        } @else {
            <li
                [class]="getClassBasedOnLink(item.link)"
                nz-menu-item
                [nzSelected]="matcher(item, item.matcher)"
                [title]="item.title || item.text | translate"
            >
                <a
                    (click)="onClickEvent($event, item)"
                    [routerLink]="item.callback ? undefined : item.link"
                    [queryParams]="item.callback ? undefined : getQueryParamsForLink(item)"
                >
                    @if (item.icon) {
                        <nz-icon [nzType]="item.icon" />
                    }
                    {{ (!isCollapsed ? item.text : "") | translate }}
                </a>
            </li>
        }
    }
</ul>
